import styled from 'styled-components';

const Alert = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;

	&.alert-small {
		flex-wrap: unset;
	}

	&.alert-column {
		flex-direction: column;

		i {
			margin-bottom: 1rem;
			margin-right: 0;
		}
	}

	i {
		margin-right: 1rem;
		font-size: 24px;
	}

	a,
	button {
		margin-left: auto;
	}

	.action-group {
		margin-left: auto;
		display: flex;
		gap: 1rem;

		button {
			margin-left: unset;
		}
	}

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: center;
		gap: 1.5rem;

		i {
			margin-right: 0;
		}

		a,
		button {
			margin-left: 0;
		}

		.action-group {
			margin-left: 0;
			button {
				margin-left: unset;
			}
		}
	}
`;

export default Alert;
